import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {speedTestReport_template} from "../components/templates/speedTestReport_template";

declare var ko: any;
declare var page: any;

export class speedTestReport extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected speedTestReport_template: speedTestReport_template;

    protected getModuleName(){
        return "speedTestReport";
    }

    buildContent() : Array<Element>{

        this.speedTestReport_template = new speedTestReport_template( "speedTestReport", this.viewModel, this );
        this.template = this.speedTestReport_template;

        return [this.speedTestReport_template.build()];
    }

    public fillPage() : void {

        this.speedTestReport_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        this.loadingIn(this.speedTestReport_template.builtTemplate);

        let usrReq_url: string = '/api/speedTest/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReportFormData;
        this.XHRHdl.execute();
    }

    protected onGetReportFormData(req, obj) {

        return function(){

            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){
                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();
                    obj.getReportData();
                }
            });

            obj.loadingOut(obj.speedTestReport_template.builtTemplate);
        }
    }

    public getReportData(): void {

        this.loadingIn(this.speedTestReport_template.builtTemplate.children.namedItem("list-results"));
        this.speedTestReport_template.getTemplateViewModel().isDataLoading(1);

        let subViewModel = this.speedTestReport_template.getViewModelForRequest();
        let baseApiUrl: string = '/api/speedTest/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetReportData, XMLHttpRequestHandler_requestType.GET, 'getReportData')
    }

    protected onGetReportData(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.updateList(responseParsed);
                }
            });

            obj.loadingOut(obj.speedTestReport_template.builtTemplate.children.namedItem("list-results"));
            obj.speedTestReport_template.getTemplateViewModel().isDataLoading(0);
        }
    }

    protected updateFilters(responseParsed: any) {
        this.speedTestReport_template.setPermissions(responseParsed.permissions)
        this.speedTestReport_template.setViewModesItems();

        this.speedTestReport_template.setGa4VitalsDateLevelsItems();
        this.speedTestReport_template.setGa4VitalsDevicesItems();
        this.speedTestReport_template.setGa4VitalsComponentsItems();
        this.speedTestReport_template.setBrandFilterItems(responseParsed.departments);
        this.speedTestReport_template.setCountriesFilterItems(responseParsed.countries);

        this.speedTestReport_template.setInsightsDateLevelsItems();
        this.speedTestReport_template.setInsightsDevicesItems();
        this.speedTestReport_template.setInsightsDomainItems(responseParsed.domainsInsights);
        this.speedTestReport_template.setInsightsComponentsItems();

        this.speedTestReport_template.setCruxDateLevelsItems();
        this.speedTestReport_template.setCruxDevicesItems();
        this.speedTestReport_template.setCruxDataAggregationsItems();
        this.speedTestReport_template.setCruxDomainItems(responseParsed.domainsCrux);
        this.speedTestReport_template.setCruxComponentsItems();
        this.speedTestReport_template.setCruxThresholdsItems();
        this.speedTestReport_template.setAllDomain(responseParsed.domains);
        this.speedTestReport_template.setCruxSiteTypeItems(responseParsed.types);


        this.speedTestReport_template.setAdsAuditTableHeaderdItems();
        this.speedTestReport_template.setAdsAuditDataViewsItems();
        this.speedTestReport_template.setAdsAuditDateLevelsItems();
        this.speedTestReport_template.setAdsAuditDevicesItems();
        this.speedTestReport_template.setAdsAuditDomainItems(responseParsed.domainsAdsAudit);
        this.speedTestReport_template.setAdsAuditComponentsItems();
    }

    protected updateList(responseParsed: any) {

        this.speedTestReport_template.setPageSpeedCruxBenchmarkVisible(false);
        this.speedTestReport_template.setInsightsBenchmarkVisible(false);

        if (this.speedTestReport_template.getTemplateViewModel().viewModeSelected() == 'ga4vitals') {

            this.speedTestReport_template.setGraphLinesInfo(responseParsed.data.graphLinesInfo);
            this.speedTestReport_template.updateGraphData(responseParsed.data.data);
        }
        else if (this.speedTestReport_template.getTemplateViewModel().viewModeSelected() == 'timeline') {

            this.speedTestReport_template.setInsightsPageTypesItems(responseParsed.data.availablePageTypes);
            this.speedTestReport_template.setGraphLinesInfo(responseParsed.data.graphLinesInfo);
            this.speedTestReport_template.updateGraphData(responseParsed.data.data);

            this.speedTestReport_template.setInsightsBenchmarkVisible(true);
            this.speedTestReport_template.setInsightsBenchmark(responseParsed.data.insightsBenchmark);
        }else if (this.speedTestReport_template.getTemplateViewModel().viewModeSelected() == 'crux') {
            this.speedTestReport_template.setPageSpeedCruxBenchmarkVisible(true);
            this.speedTestReport_template.setPageSpeedBenchmark(responseParsed.data.pageSpeedBenchmark);

            this.speedTestReport_template.setGraphLinesInfo(responseParsed.data.graphLinesInfo);
            this.speedTestReport_template.setCruxThresholdsData(responseParsed.data.thresholds);
            this.speedTestReport_template.updateGraphData(responseParsed.data.data);
        } else {

            this.speedTestReport_template.setAdsAuditContentTypesItems(responseParsed.data.availableContentTypes);

            if (this.speedTestReport_template.getTemplateViewModel().adsAuditDataViewSelected() == 'graph') {

                this.speedTestReport_template.setGraphLinesInfo(responseParsed.data.graphLinesInfo);
                this.speedTestReport_template.updateGraphData(responseParsed.data.data);
            }else {

                this.speedTestReport_template.setAdsAuditTableData(responseParsed.data.data);
            }
        }

    }

    protected filterSingleDateOnChange() {

        this.getReportData();
    }

    protected filterMultipleSelectorOnChange(id) {

        this.speedTestReport_template.processMultipleSelectorChange(id);
        this.getReportData();
    }

    protected filterDateOnChange() {

        this.getReportData();
    }

    protected filterSimpleOnChange() {

        this.getReportData();
    }

    protected filterDropdownOnChange(){

        this.getReportData();
    }

    protected configSpeedTest(){

        page('/speed_test/config_insights/');
    }

    protected configCrux(){

        page('/speed_test/config_crux/');
    }

    protected configAdsAudit(){

        page('/speed_test/config_ads_audit/');
    }

    public dataReorder(id) {

        this.getReportData();
    }

    public getCruxExcelPageSpeedData() {

        this.loadingIn(this.speedTestReport_template.builtTemplate.children.namedItem("list-results"));
        this.XHRHdl.cancelAndReset();
        let baseApiUrl = '/api/speedTest/excelExport/';

        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl,[], this);

        this.XHRHdl.onReadyStateFunction = this.onCruxExcelRequestReturn;
        this.XHRHdl.execute();
    }

    private onCruxExcelRequestReturn(req, obj) {
        return function (){

            obj.manageResponse(req, obj, function (){
                let responseParsed = JSON.parse(req.request.response);
                obj.speedTestReport_template.setCruxExcelData(responseParsed.cruxExcelData);
                obj.speedTestReport_template.exportCruxExcelHtmlData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.speedTestReport_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

}



// WEBPACK FOOTER //
// ./js/modules/speedTestReport.ts